export default __webpack_public_path__ + "static/media/reset-password.fcd97cab.svg";